<div class="search-criteria">
  <div class="criteria-header"> {{criteriaTitle}} </div>
  <mat-select multiple panelClass="criteria-dropdown-panel"
    (blur) = 'setErrorState()'
    (selectionChange) = 'setErrorState()'
    [ngClass]="errorState ? 'criteria-dropdown criteria-error':'criteria-dropdown'"
    [formControl]="form"
    [placeholder]="placeholderText">
    <mat-select-trigger>
      @if (form.value !== null && form.value.length > 1 && form.value.length < searchOptions.length) {
        {{form.value.length}} {{plural}}
      }
      @if (form.value !== null && form.value.length >= searchOptions.length) {
        All
      }
      @if (form.value !== null && form.value.length == 1) {
        {{form.value[0].valueTitle}}
      }
    </mat-select-trigger>
    <mat-checkbox [ngClass]="'select-all-spacer'"
      (click)="toggleAllSelection()"
      [indeterminate]="isIndeterminate()"
      [checked]="isChecked()"
      [disableRipple]="true">
    All </mat-checkbox>
    @for (option of searchOptions; track option) {
      <mat-option [value]="option">
        {{option.valueTitle}}
      </mat-option>
    }
  </mat-select>

  @if (errorState) {
    <div class="criteria-error-text mat-small">
      {{errorMessage}}
    </div>
  }
</div>
